/**
 * Loading indicator component
 */
export default function Loader() {
  return <div className="loader">Loading...</div>;
}

